// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Navigation__Item$PrezzeeRibbon from "./Navigation__Item.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

function Component(T) {
  var styling = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.listStyleType("none"),
        BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
        BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.zero),
        BsCssJs$PrezzeeRibbon.display("flex"),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.largeScreen, [
              BsCssJs$PrezzeeRibbon.alignItems(BsCssJs$PrezzeeRibbon.stretch),
              BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))
            ]),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [
              BsCssJs$PrezzeeRibbon.flexDirection("column"),
              BsCssJs$PrezzeeRibbon.alignItems("flexStart")
            ])
      ]);
  var Styles = {
    styling: styling
  };
  var Item = Navigation__Item$PrezzeeRibbon.Component(T);
  var Navigation$Component = function (props) {
    return JsxRuntime.jsx("nav", {
                children: JsxRuntime.jsx("ul", {
                      children: props.children,
                      className: styling
                    })
              });
  };
  return {
          Styles: Styles,
          Item: Item,
          make: Navigation$Component
        };
}

export {
  Component ,
}
/* react/jsx-runtime Not a pure module */
